export const formatDateTime = (dateStr) => {
    if (!dateStr) return "Invalid date";
    const date = new Date(dateStr + "Z");
    if (isNaN(date.getTime())) return "Invalid date";

    const formatter = new Intl.DateTimeFormat("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    return formatter.format(date);
  };

export const formatDate = (dateString) => {
    const date = new Date(dateString  + "Z");
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}/${month}/${year} ${hours}:${minutes}`;
};


const gcd = (a, b) => {
  return b === 0 ? a : gcd(b, a % b);
};

const decimalToFraction = (decimal) => {
  const value = decimal - 1;
  const precision = 10000;
  const numerator = Math.round(value * precision);
  const denominator = precision;

  const divisor = gcd(numerator, denominator);
  const simplifiedNumerator = numerator / divisor;
  const simplifiedDenominator = denominator / divisor;

  return `${simplifiedNumerator}/${simplifiedDenominator}`;
};


export const totalOddsCal = (oddsFormat, data, multi=false) => {
  if (!data || !Array.isArray(data)) return 0;

  const oddsStrings = data
    .map((item) => item.odds?.decimalodds)
    .filter((odd) => !isNaN(parseFloat(odd)));

  const totalLegs = oddsStrings.length;
  if (totalLegs === 0) return 0;

  const odds = oddsStrings.map((odd) => parseFloat(odd));

  let totalOddsDecimal = 0;

  if (totalLegs === 1) {
    totalOddsDecimal = odds[0];
  } else {
    // const productOfOdds = odds.reduce((acc, curr) => acc * curr, 1);  // multiple all show odds
    // const adjustmentFactor = 1 - totalLegs * 0.1;    // totallegs
    // totalOddsDecimal = productOfOdds * adjustmentFactor;

    // Step 1: Multiply all odds together
      const productOfOdds = odds.reduce((acc, curr) => acc * curr, 1);
    // Step 2: Calculate n
    const n = totalLegs;

      // Step 3: Calculate average of odds
      const averageOdds = odds.reduce((acc, curr) => acc + curr, 0) / n;

      // Step 4: Convert to implied probability m
      const m = 1 / averageOdds;

      // Step 5: Calculate factor
      const adjustmentFactor = 1 - (0.4 * ((n - 1) / n) * (1 - m));

      // Step 6: Final estimated odds
      totalOddsDecimal = productOfOdds * adjustmentFactor;
  }

  if (oddsFormat === 'EU') {
    return totalOddsDecimal.toFixed(2); 
  } else if (oddsFormat === 'US') {
    if(multi){
      return totalOddsDecimal.toFixed(2); 
    }
    if (totalOddsDecimal >= 2) {
      return `+${Math.round((totalOddsDecimal - 1) * 100)}`;
    } else {
      return `${Math.round(-100 / (totalOddsDecimal - 1))}`;
    }
  } else if (oddsFormat === 'UK') {
    return decimalToFraction(totalOddsDecimal); 
  } else {
    return 0;
  }
};

export const formatValue = (value) => {
  const num = parseFloat(value);
  if (isNaN(num)) return value; // return as-is if not a valid number
  return num >= 0 ? `+${num}` : `${num}`;
};


